import { URL_GET_APP_SETTINGS } from "@/requests/general";
import MockAdapter from "axios-mock-adapter/types";
import AppSettings from "@/models/api/AppSettings";

export const appSettingsMock = (mock: MockAdapter): void => {
  mock.onGet(URL_GET_APP_SETTINGS).reply(200, {
    showMailNotificationFunction: true,
    dataItemsPerPageOption: [5, 10, 25, 50],
  } as AppSettings);
};

export default appSettingsMock;
